import {APIEvents} from "../../../constants/AnalyticsEventKeys";
import {MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {getNPSWClient} from "../../base/ClientInterface";

export function getCategoriesForNodeIdAPI(data, dispatcher, nextAction, errorAction) {
    let startTime = Date.now();
    getNPSWClient().getCategoriesForNodeId(data)
        .then(({success, data}) => {
            if (success) {
                dispatcher({
                    type: nextAction,
                    data: data,
                    dispatcher: dispatcher
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.GetCategoriesForNodeId, startTime);
            } else {
                dispatcher({
                    type: errorAction
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.GetCategoriesForNodeId, startTime, true);
            }
        });
}